import EntityServise from "./entityService";

class AccountService extends EntityServise{
    constructor() {
        super("account")
    }
}

export default new AccountService();